const chartId = "chart-4f";
let Chart = require('chart.js');
Chart.defaults.global.defaultFontFamily = 'acumin-pro';

const _groupBy = require('lodash/groupBy')
const _each = require('lodash/each')

const data = require('./data');
const config = require('../../../config');
const full = config.colorHues.full; //full colors
const eighty = config.colorHues.eighty; //80% colors

const groupedData = _groupBy(data, "Geography");

let datasets = [];
let labels = [];
let i = 0;
_each(groupedData, function(group) {
  const obj = {
    label: group[0].Geography,
    data: [],
    backgroundColor: eighty[i],
    borderColor: full[i],
    borderWidth: 1,
    fill: false,
    lineTension: 0,
  }
  _each(group, function(row) {
    labels.push(row.Year)
    obj.data.push(row.Rate)
  })
  datasets.push(obj)
  i++;
})
labels = [...new Set(labels)]

let ctx = document.getElementById(chartId).getContext('2d');
const options = require('../chart-2a/options')
new Chart(ctx, {
  type: 'line',
  data: {
    labels: labels,
    datasets: datasets
  },
  options: options
})